<template>
  <div>
    <form
      :action="permalink"
      method="post"
      enctype="multipart/form-data"
      v-on:submit.prevent="addToCart"
      class="add-to-cart-form"
      v-if="stockStatus == 'instock'"
    >
      <WellsAddToCart
        v-if="type === 'wells'"
        :minQuantity="getMinPurchaseQuantity(minQuantity, maxQuantity)"
        :maxQuantity="getMaxPurchaseQuantity(maxQuantity)"
        :isLoading="isLoading"
        :measurementUnit="measurementUnit"
        :buyingStep="buyingStep"
        :addToCartColor="getAddToCartColor()"
        ref="add_to_cart"
      ></WellsAddToCart>
      <KaaliAddToCart
        v-if="type === 'kaali'"
        :minQuantity="getMinPurchaseQuantity(minQuantity, maxQuantity)"
        :maxQuantity="getMaxPurchaseQuantity(maxQuantity)"
        :isLoading="isLoading"
      ></KaaliAddToCart>
      <input type="hidden" name="action" value="add_to_cart" />
      <input
        v-if="variationId"
        type="hidden"
        name="variation_id"
        :value="variationId"
      />
      <input type="hidden" name="product_id" :value="id" />
    </form>
    <KaaliSuccess v-if="showSuccessMessage" :message="translations.product_added_to_cart"></KaaliSuccess>
    <KaaliError v-if="showErrorMessage" :message="errorMessage"></KaaliError>
    <div v-if="stockStatus != 'instock'" class="out-of-stock"><span>{{translations.outOfStock}} <button @click="showForm" class="out-of-stock-button">?</button></span></div>
  </div>
</template>

<script>
import FragmentsRenderer from "@/externals/FragmentRenderer";
import WellsAddToCart from "@/components/general-ui/addtocarts/Wells.vue";
import KaaliAddToCart from "@/components/general-ui/addtocarts/Kaali.vue";
import KaaliSuccess from "@/components/general-ui/messages/success/Kaali.vue";
import KaaliError from "@/components/general-ui/messages/error/Kaali.vue";

export default {
  name: "AddToCart",
  components: {
    WellsAddToCart,
    KaaliAddToCart,
    KaaliSuccess,
    KaaliError
  },
  props: {
    name: String,
    sku: String,
    permalink: String,
    id: Number,
    variationId: Number,
    minQuantity: Number,
    maxQuantity: Number,
    soldIndividually: Boolean,
    measurementUnit: String,
    buyingStep: Number,
    stockStatus: String
  },
  data() {
    return {
      type: ws_vue_store.config["add-to-cart"],
      isLoading: false,
      showSuccessMessage: false,
      showErrorMessage: false,
      changeAddToCartColor: false,
      errorMessage: '',
      translations: {
        product_added_to_cart: ws_vue_store.translations.product_added_to_cart,
        outOfStock: ws_vue_store.translations.out_of_stock
      }
    };
  },
  methods: {
    getMaxPurchaseQuantity(maxQuantity) {
      if (this.soldIndividually) {
        return 1;
      }
      return maxQuantity < 0 ? 9999999 : maxQuantity;
    },
    getMinPurchaseQuantity(minQuantity, maxQuantity) {
      return this.getMaxPurchaseQuantity(maxQuantity) === 0 ? 1 : minQuantity;
    },
    checkBuyingStep(element){
      let step = ws_vue_store.enable_buying_step != '1' ? this.getMinPurchaseQuantity(this.minQuantity, this.maxQuantity) : this.buyingStep;
      let quantity = element != null ? Number(element.value) : 1;
      if(this.$refs.add_to_cart != undefined){
        this.$refs.add_to_cart.setInputValue(quantity, step, this.getMaxPurchaseQuantity(this.maxQuantity));
      }
    },
    addToCart(event) {
      this.checkBuyingStep(event.target.querySelector('input[name="quantity"]'));
      const self = this;
      this.isLoading = true;
      this.axios
        .post(
          wc_add_to_cart_params.wc_ajax_url
            .toString()
            .replace("%%endpoint%%", "add_to_cart"),
          new FormData(event.target)
        )
        .then(result => {
          if (result.data.fragments) {
            self.isLoading = false;
            FragmentsRenderer.renderFragments(result.data.fragments);
            self.showSuccessMessage = true;
            self.changeAddToCartColor = true;
            setTimeout(function(){ self.showSuccessMessage = false; }, 3000);
            self.$store.commit("setRecentlyAddedProduct", self.id);
          } else if(result.data.error) {
            self.getErrorMessages();
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {});
    },
    getErrorMessages(){
      const self = this;
      this.axios
        .get(ws_vue_store.ajax_url + '?action=get_cart_error_messages')
        .then(response => {
          self.isLoading = false;
          if(response.data){
            self.errorMessage = response.data[0];
            self.showErrorMessage = true;
            setTimeout(function(){ self.showErrorMessage = false; }, 3000);
          }       
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
    },
    showForm(e){
      e.preventDefault();
      document.querySelector('.out_of_stock_contact_form input[name="your-subject"]').value = this.name + ' - ' + this.sku;
      document.querySelector('.out_of_stock_contact_form').style.display = 'block';
      document.querySelector('.out_of_stock_contact_form_close_btn').addEventListener('click', function(){
        document.querySelector('.out_of_stock_contact_form').style.display = 'none';
      });
    },
    getAddToCartColor(){
      if(ws_vue_store.change_add_to_cart_color == '1' && (this.changeAddToCartColor || ws_vue_store.cart_items.includes(this.id) || this.$store.getters.getRecentlyAddedProducts.includes(this.id))){
        return ws_vue_store.add_to_cart_color;
      }
      return '';
    }
  }
};
</script>
